import React from "react";
export default function TopNav() {
  return (
    <div className="sub-header">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-sm-8">
            <div className="left-content">
              {/* <p>
                This is an educational <em>HTML CSS</em> template by TemplateMo website.
              </p> */}
            </div>
          </div>
          <div className="col-lg-4 col-sm-4">
            <div className="right-icons">
              <ul>
                <li>
                  <a href="#" aria-label="Facebook">
                    <i className="fa fa-facebook" />
                  </a>
                </li>
                <li>
                  <a href="#" aria-label="Twitter">
                    <i className="fa fa-twitter" />
                  </a>
                </li>
                <li>
                  <a href="#" aria-label="Behance">
                    <i className="fa fa-behance" />
                  </a>
                </li>
                <li>
                  <a href="#" aria-label="LinkedIn">
                    <i className="fa fa-linkedin" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>      
    </div>
  );
}
